var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 10.7094V6.02088C11.6875 5.62967 12.0046 5.31254 12.3958 5.31254C12.787 5.31254 13.1041 5.62967 13.1041 6.02088V12.3959C13.1041 12.3988 13.1041 12.4017 13.1041 12.4047C13.1061 12.5843 13.0386 12.7646 12.9016 12.9016C12.7644 13.0388 12.5838 13.1064 12.404 13.1042C12.4013 13.1042 12.3986 13.1042 12.3958 13.1042H6.02081C5.6296 13.1042 5.31248 12.7871 5.31248 12.3959C5.31248 12.0047 5.6296 11.6875 6.02081 11.6875H10.7094L4.0984 5.07659C3.82828 4.80648 3.82828 4.36856 4.0984 4.09846C4.36848 3.82835 4.80643 3.82835 5.07651 4.09846L11.6875 10.7094Z",
    fill: "#009C8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowGreen);
export default __webpack_public_path__ + "static/media/down-arrow-green.47abba61b38de5aae24112a9fe7d0742.svg";
export { ForwardRef as ReactComponent };